import React from "react";
import { FormattedMessage } from "react-intl";
import { ConfirmDialogControl } from "../../hooks/useConfirmDialog";
import { ConfirmDialog } from "../ConfirmDialog";
import { extraImpactDialogMessages as messages } from "./ExtraImpactDialog.messages";
import { ExtraChangeBlockedView } from "./extraImpactDialog.viewModel";
import { ImpactSections } from "./ImpactSections";

/**
 * The change would leave an active block with no active extra, so it is not sent; the only action
 * is *Close*.
 */
export function ExtraChangeBlockedDialog({
  show,
  content,
  onConfirm,
  onCancel,
}: ConfirmDialogControl<ExtraChangeBlockedView>) {
  return (
    <ConfirmDialog
      show={show}
      title={<FormattedMessage {...messages.blockedTitle} />}
      confirmLabel={<FormattedMessage {...messages.close} />}
      onConfirm={onConfirm}
      onCancel={onCancel}>
      <ImpactSections sections={content?.sections ?? []} />
    </ConfirmDialog>
  );
}
